import React, { useEffect, useState } from "react";
import searcher from "../../assets/searchInput.svg";
import ManageOrderTable from "./manageOrderTable";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

const ManageOrderList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const filterStoredData = {
    invStatus: queryParamsData.get("invStatus") ?? "",
    order_date_from: queryParamsData.get("order_date_from") ?? "",
    order_date_to: queryParamsData.get("order_date_to") ?? "",
    order_value_from: queryParamsData.get("order_value_from") ?? "",
    order_value_to: queryParamsData.get("order_value_to") ?? "",
    status: queryParamsData.get("status") ?? "",
  };
  const orderStatusArray = filterStoredData?.status
    ? filterStoredData?.status?.split(",")
    : [];
  const [invStatus, setInvStatus] = useState(filterStoredData?.invStatus ?? "");
  const [order_date_from, setOrder_date_from] = useState(
    filterStoredData?.order_date_from ?? ""
  );
  const [order_date_to, setOrder_date_to] = useState(
    filterStoredData?.order_date_to ?? ""
  );
  const [order_value_from, setOrder_value_from] = useState(
    filterStoredData?.order_value_from ?? ""
  );
  const [order_value_to, setOrder_value_to] = useState(
    filterStoredData?.order_value_to ?? ""
  );
  const [status, setStatus] = useState(orderStatusArray ?? []);

  useEffect(() => {
    if (filterStoredData?.invStatus) {
      setInvStatus(filterStoredData?.invStatus ?? "");
    } else {
      setInvStatus("");
    }
    if (filterStoredData?.order_date_from) {
      setOrder_date_from(filterStoredData?.order_date_from ?? "");
    } else {
      setOrder_date_from("");
    }
    if (filterStoredData?.order_date_to) {
      setOrder_date_to(filterStoredData?.order_date_to ?? "");
    } else {
      setOrder_date_to("");
    }
    if (filterStoredData?.order_value_from) {
      setOrder_value_from(filterStoredData?.order_value_from);
    } else {
      setOrder_value_from("");
    }
    if (filterStoredData?.order_value_to) {
      setOrder_value_to(filterStoredData?.order_value_to ?? "");
    } else {
      setOrder_value_to("");
    }
  }, [
    filterStoredData?.invStatus,
    filterStoredData?.order_date_from,
    filterStoredData?.order_date_to,
    filterStoredData?.order_value_from,
    filterStoredData?.order_value_to,
  ]);

  useEffect(() => {
    if (filterStoredData?.status) {
      setStatus(filterStoredData?.status?.split(","));
    } else if (filterStoredData?.status === undefined) {
      setStatus([]);
    } else {
      setStatus([]);
    }
  }, [filterStoredData?.status]);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/manage-order",
      breadcrumb: " / manage orders",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];

  if (filterStoredData?.invStatus)
    queryParams.push(`invStatus=${filterStoredData?.invStatus}`);
  if (filterStoredData?.order_value_from)
    queryParams.push(`order_value_from=${filterStoredData?.order_value_from}`);
  if (filterStoredData?.order_value_to)
    queryParams.push(`order_value_to=${filterStoredData?.order_value_to}`);
  if (filterStoredData?.order_date_from)
    queryParams.push(`order_date_from=${filterStoredData?.order_date_from}`);
  if (filterStoredData?.order_date_to)
    queryParams.push(`order_date_to=${filterStoredData?.order_date_to}`);
  if (filterStoredData?.status)
    queryParams.push(`status=${filterStoredData?.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div className="">
            <div className="search-container d-flex justify-content-between align-items-center w-100">
              <div className="search-box d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  value={search}
                  className="search-input text-dark fw_400 px-2"
                  type="text"
                  placeholder="Search Order ID, etc. "
                  onChange={(e) => {
                    navigate(
                      `/manage-order?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                />
              </div>
              <button
                onClick={() => navigate(`/manage-order`)}
                className="py-2 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
              >
                Clear Filters
              </button>
            </div>
            <ManageOrderTable
              search={search}
              setInvStatus={setInvStatus}
              invStatus={invStatus}
              setStatus={setStatus}
              status={status}
              setOrder_date_to={setOrder_date_to}
              order_date_to={order_date_to}
              setOrder_date_from={setOrder_date_from}
              order_date_from={order_date_from}
              setOrder_value_to={setOrder_value_to}
              order_value_to={order_value_to}
              setOrder_value_from={setOrder_value_from}
              order_value_from={order_value_from}
              page_no={page_no}
              filterStoredData={filterStoredData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageOrderList;
